<!-- src/views/IncidentView.vue -->
<template>
  <div class="container incident-view">
    <VenueIncidentPanel v-if="venueId" :venue-id="venueId" :key="venueId" />
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useVenueContext } from "@/scripts/useScripts/useVenueContext";
import VenueIncidentPanel from "@/components/incidents/VenueIncidentPanel.vue";

const { venueId } = useVenueContext();

const reactiveVenueId = computed(() => venueId.value);
</script>

<style scoped>
.incident-view {
  margin-top: 24px;
}

@media (max-width: 600px) {
  .incident-view {
    width: 96%;
    margin-top: 14px;
  }

  .incident-view :deep(.card-content) {
    padding: 14px;
  }

  .incident-view :deep(table) {
    min-width: 680px;
  }

  .incident-view :deep(.responsive-table),
  .incident-view :deep(.table-wrap) {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
</style>
